import { ALL_FORM_NUTRIENTS } from "shared-ui/NutrientAmount/customNutrientUtils";
import { convertVitaminDToIU } from "shared-ui/NutrientAmount/unitConversionUtils";

type NutrientName = (typeof ALL_FORM_NUTRIENTS)[number];

export interface NutrientImportEntry {
  header: string;
  nutrient: NutrientName;
  toCanonical?: (val: number) => number;
}

export const NUTRIENT_IMPORT_REGISTRY: readonly NutrientImportEntry[] = [
  { header: "Fiber, g", nutrient: "Fiber, total dietary" },
  { header: "Starch, g", nutrient: "Starch" },
  { header: "Total Sugars, g", nutrient: "Sugars, total including NLEA" },
  { header: "Added Sugars, g", nutrient: "Sugars, added" },
  { header: "Saturated Fat, g", nutrient: "Fatty acids, total saturated" },
  { header: "Trans Fat, g", nutrient: "Fatty acids, total trans" },
  { header: "Monounsaturated Fat, g", nutrient: "Fatty acids, total monounsaturated" },
  { header: "Polyunsaturated Fat, g", nutrient: "Fatty acids, total polyunsaturated" },
  { header: "Cholesterol, mg", nutrient: "Cholesterol" },
  { header: "ALA, g", nutrient: "18:3 n-3 c,c,c (ALA)" },
  { header: "EPA, g", nutrient: "20:5 n-3 (EPA)" },
  { header: "DPA, g", nutrient: "22:5 n-3 (DPA)" },
  { header: "DHA, g", nutrient: "22:6 n-3 (DHA)" },
  { header: "Linoleic Acid, g", nutrient: "18:2 n-6 c,c" },
  { header: "Arginine, g", nutrient: "Arginine" },
  { header: "Alanine, g", nutrient: "Alanine" },
  { header: "Cysteine, g", nutrient: "Cystine" },
  { header: "Glutamate, g", nutrient: "Glutamic acid" },
  { header: "Glutamine, g", nutrient: "Glutamine" },
  { header: "Glycine, g", nutrient: "Glycine" },
  { header: "Histidine, g", nutrient: "Histidine" },
  { header: "Isoleucine, g", nutrient: "Isoleucine" },
  { header: "Leucine, g", nutrient: "Leucine" },
  { header: "Lysine, g", nutrient: "Lysine" },
  { header: "Methionine, g", nutrient: "Methionine" },
  { header: "Phenylalanine, g", nutrient: "Phenylalanine" },
  { header: "Proline, g", nutrient: "Proline" },
  { header: "Threonine, g", nutrient: "Threonine" },
  { header: "Tryptophan, g", nutrient: "Tryptophan" },
  { header: "Tyrosine, g", nutrient: "Tyrosine" },
  { header: "Valine, g", nutrient: "Valine" },
  { header: "Thiamin (B1), mg", nutrient: "Thiamin" },
  { header: "Riboflavin (B2), mg", nutrient: "Riboflavin" },
  { header: "Niacin (B3), mg", nutrient: "Niacin" },
  { header: "Pantothenic Acid (B5), mg", nutrient: "Pantothenic acid" },
  { header: "Pyridoxine (B6), mg", nutrient: "Vitamin B-6" },
  { header: "Biotin (B7), mcg", nutrient: "Biotin" },
  { header: "Cobalamin (B12), mcg", nutrient: "Vitamin B-12" },
  { header: "Folate (B9), mcg", nutrient: "Folate, DFE" },
  { header: "Vitamin A, mcg", nutrient: "Vitamin A, RAE" },
  { header: "Vitamin C, mg", nutrient: "Vitamin C, total ascorbic acid" },
  { header: "Vitamin D, mcg", nutrient: "Vitamin D (D2 + D3), International Units", toCanonical: convertVitaminDToIU },
  { header: "Vitamin E, mg", nutrient: "Vitamin E (alpha-tocopherol)" },
  { header: "Vitamin K, mcg", nutrient: "Vitamin K (phylloquinone)" },
  { header: "Calcium, mg", nutrient: "Calcium, Ca" },
  { header: "Copper, mg", nutrient: "Copper, Cu" },
  { header: "Iron, mg", nutrient: "Iron, Fe" },
  { header: "Magnesium, mg", nutrient: "Magnesium, Mg" },
  { header: "Manganese, mg", nutrient: "Manganese, Mn" },
  { header: "Phosphorus, mg", nutrient: "Phosphorus, P" },
  { header: "Potassium, mg", nutrient: "Potassium, K" },
  { header: "Selenium, mcg", nutrient: "Selenium, Se" },
  { header: "Sodium, mg", nutrient: "Sodium, Na" },
  { header: "Zinc, mg", nutrient: "Zinc, Zn" },
  { header: "Alcohol, g", nutrient: "Alcohol, ethyl" },
  { header: "Caffeine, mg", nutrient: "Caffeine" },
  { header: "Choline, mg", nutrient: "Choline, total" },
  { header: "Water, g", nutrient: "Water" },
];
